import { useUnit } from 'effector-react';
import styled, { keyframes } from 'styled-components';
import { $toasts } from '@/model/toasts';

const fade = keyframes`from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); }`;

const Stack = styled.div`
  position: fixed;
  bottom: ${({ theme }) => theme.spacing[6]};
  right: ${({ theme }) => theme.spacing[6]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
  z-index: 140;
  pointer-events: none;
`;

const Item = styled.div`
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
  background: ${({ theme }) => theme.surface.ink};
  color: ${({ theme }) => theme.surface.bg};
  border-radius: ${({ theme }) => theme.radii.pill};
  box-shadow: ${({ theme }) => theme.shadows.sh3};
  font-size: ${({ theme }) => theme.typography.fontSizes.ui};
  font-family: ${({ theme }) => theme.typography.fontFamilies.sans};
  animation: ${fade} ${({ theme }) => theme.motion.duration.base} ${({ theme }) => theme.motion.easing.out};
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.tone.halo.base};
`;

export const Toasts = () => {
  const toasts = useUnit($toasts);

  return (
    <Stack>
      {toasts.map((t) => (
        <Item key={t.id}>
          <Dot />
          {t.text}
        </Item>
      ))}
    </Stack>
  );
};
